import { setLogLevel as Hn, LogLevel as St, setLogExtension as zn, RoomEvent as y, ParticipantEvent as w, Track as R, TrackEvent as Yt, getBrowser as Yn, compareVersions as qn, Room as Tt } from "livekit-client";
import * as I from "react";
const De = Math.min, ae = Math.max, $e = Math.round, _e = Math.floor, Q = (e) => ({
  x: e,
  y: e
}), Kn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Gn = {
  start: "end",
  end: "start"
};
function Et(e, t, n) {
  return ae(e, De(t, n));
}
function He(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ce(e) {
  return e.split("-")[0];
}
function ze(e) {
  return e.split("-")[1];
}
function qt(e) {
  return e === "x" ? "y" : "x";
}
function Kt(e) {
  return e === "y" ? "height" : "width";
}
function ve(e) {
  return ["top", "bottom"].includes(ce(e)) ? "y" : "x";
}
function Gt(e) {
  return qt(ve(e));
}
function Qn(e, t, n) {
  n === void 0 && (n = !1);
  const r = ze(e), i = Gt(e), o = Kt(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = Ne(s)), [s, Ne(s)];
}
function Jn(e) {
  const t = Ne(e);
  return [ot(e), t, ot(t)];
}
function ot(e) {
  return e.replace(/start|end/g, (t) => Gn[t]);
}
function Xn(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : s;
    default:
      return [];
  }
}
function Zn(e, t, n, r) {
  const i = ze(e);
  let o = Xn(ce(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(ot)))), o;
}
function Ne(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Kn[t]);
}
function er(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function tr(e) {
  return typeof e != "number" ? er(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Fe(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function Ct(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = ve(t), s = Gt(t), a = Kt(s), c = ce(t), u = o === "y", l = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, v = r[a] / 2 - i[a] / 2;
  let d;
  switch (c) {
    case "top":
      d = {
        x: l,
        y: r.y - i.height
      };
      break;
    case "bottom":
      d = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      d = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      d = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      d = {
        x: r.x,
        y: r.y
      };
  }
  switch (ze(t)) {
    case "start":
      d[s] -= v * (n && u ? -1 : 1);
      break;
    case "end":
      d[s] += v * (n && u ? -1 : 1);
      break;
  }
  return d;
}
const nr = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: l,
    y: f
  } = Ct(u, r, c), v = r, d = {}, m = 0;
  for (let p = 0; p < a.length; p++) {
    const {
      name: g,
      fn: h
    } = a[p], {
      x,
      y: E,
      data: O,
      reset: b
    } = await h({
      x: l,
      y: f,
      initialPlacement: r,
      placement: v,
      strategy: i,
      middlewareData: d,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    l = x ?? l, f = E ?? f, d = {
      ...d,
      [g]: {
        ...d[g],
        ...O
      }
    }, b && m <= 50 && (m++, typeof b == "object" && (b.placement && (v = b.placement), b.rects && (u = b.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : b.rects), {
      x: l,
      y: f
    } = Ct(u, v, c)), p = -1);
  }
  return {
    x: l,
    y: f,
    placement: v,
    strategy: i,
    middlewareData: d
  };
};
async function Qt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: f = "floating",
    altBoundary: v = !1,
    padding: d = 0
  } = He(t, e), m = tr(d), g = a[v ? f === "floating" ? "reference" : "floating" : f], h = Fe(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(g))) == null || n ? g : g.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: l,
    strategy: c
  })), x = f === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, E = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), O = await (o.isElement == null ? void 0 : o.isElement(E)) ? await (o.getScale == null ? void 0 : o.getScale(E)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = Fe(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: E,
    strategy: c
  }) : x);
  return {
    top: (h.top - b.top + m.top) / O.y,
    bottom: (b.bottom - h.bottom + m.bottom) / O.y,
    left: (h.left - b.left + m.left) / O.x,
    right: (b.right - h.right + m.right) / O.x
  };
}
const rr = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: s,
        initialPlacement: a,
        platform: c,
        elements: u
      } = t, {
        mainAxis: l = !0,
        crossAxis: f = !0,
        fallbackPlacements: v,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: p = !0,
        ...g
      } = He(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const h = ce(i), x = ve(a), E = ce(a) === a, O = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), b = v || (E || !p ? [Ne(a)] : Jn(a)), S = m !== "none";
      !v && S && b.push(...Zn(a, p, m, O));
      const C = [a, ...b], $ = await Qt(t, g), M = [];
      let z = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (l && M.push($[h]), f) {
        const G = Qn(i, s, O);
        M.push($[G[0]], $[G[1]]);
      }
      if (z = [...z, {
        placement: i,
        overflows: M
      }], !M.every((G) => G <= 0)) {
        var T, _;
        const G = (((T = o.flip) == null ? void 0 : T.index) || 0) + 1, ke = C[G];
        if (ke)
          return {
            data: {
              index: G,
              overflows: z
            },
            reset: {
              placement: ke
            }
          };
        let Se = (_ = z.filter((de) => de.overflows[0] <= 0).sort((de, ne) => de.overflows[1] - ne.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!Se)
          switch (d) {
            case "bestFit": {
              var Z;
              const de = (Z = z.filter((ne) => {
                if (S) {
                  const re = ve(ne.placement);
                  return re === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  re === "y";
                }
                return !0;
              }).map((ne) => [ne.placement, ne.overflows.filter((re) => re > 0).reduce((re, Vn) => re + Vn, 0)]).sort((ne, re) => ne[1] - re[1])[0]) == null ? void 0 : Z[0];
              de && (Se = de);
              break;
            }
            case "initialPlacement":
              Se = a;
              break;
          }
        if (i !== Se)
          return {
            reset: {
              placement: Se
            }
          };
      }
      return {};
    }
  };
};
async function ir(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = ce(n), a = ze(n), c = ve(n) === "y", u = ["left", "top"].includes(s) ? -1 : 1, l = o && c ? -1 : 1, f = He(t, e);
  let {
    mainAxis: v,
    crossAxis: d,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof m == "number" && (d = a === "end" ? m * -1 : m), c ? {
    x: d * l,
    y: v * u
  } : {
    x: v * u,
    y: d * l
  };
}
const or = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = t, c = await ir(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, sr = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (g) => {
            let {
              x: h,
              y: x
            } = g;
            return {
              x: h,
              y: x
            };
          }
        },
        ...c
      } = He(e, t), u = {
        x: n,
        y: r
      }, l = await Qt(t, c), f = ve(ce(i)), v = qt(f);
      let d = u[v], m = u[f];
      if (o) {
        const g = v === "y" ? "top" : "left", h = v === "y" ? "bottom" : "right", x = d + l[g], E = d - l[h];
        d = Et(x, d, E);
      }
      if (s) {
        const g = f === "y" ? "top" : "left", h = f === "y" ? "bottom" : "right", x = m + l[g], E = m - l[h];
        m = Et(x, m, E);
      }
      const p = a.fn({
        ...t,
        [v]: d,
        [f]: m
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - r,
          enabled: {
            [v]: o,
            [f]: s
          }
        }
      };
    }
  };
};
function Ye() {
  return typeof window < "u";
}
function ye(e) {
  return Jt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function W(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function X(e) {
  var t;
  return (t = (Jt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Jt(e) {
  return Ye() ? e instanceof Node || e instanceof W(e).Node : !1;
}
function q(e) {
  return Ye() ? e instanceof Element || e instanceof W(e).Element : !1;
}
function J(e) {
  return Ye() ? e instanceof HTMLElement || e instanceof W(e).HTMLElement : !1;
}
function Pt(e) {
  return !Ye() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof W(e).ShadowRoot;
}
function Oe(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = K(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function ar(e) {
  return ["table", "td", "th"].includes(ye(e));
}
function qe(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function dt(e) {
  const t = pt(), n = q(e) ? K(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function cr(e) {
  let t = oe(e);
  for (; J(t) && !me(t); ) {
    if (dt(t))
      return t;
    if (qe(t))
      return null;
    t = oe(t);
  }
  return null;
}
function pt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function me(e) {
  return ["html", "body", "#document"].includes(ye(e));
}
function K(e) {
  return W(e).getComputedStyle(e);
}
function Ke(e) {
  return q(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function oe(e) {
  if (ye(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Pt(e) && e.host || // Fallback.
    X(e)
  );
  return Pt(t) ? t.host : t;
}
function Xt(e) {
  const t = oe(e);
  return me(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : J(t) && Oe(t) ? t : Xt(t);
}
function Ee(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Xt(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), s = W(i);
  if (o) {
    const a = st(s);
    return t.concat(s, s.visualViewport || [], Oe(i) ? i : [], a && n ? Ee(a) : []);
  }
  return t.concat(i, Ee(i, [], n));
}
function st(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Zt(e) {
  const t = K(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = J(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, a = $e(n) !== o || $e(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function ht(e) {
  return q(e) ? e : e.contextElement;
}
function pe(e) {
  const t = ht(e);
  if (!J(t))
    return Q(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = Zt(t);
  let s = (o ? $e(n.width) : n.width) / r, a = (o ? $e(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const ur = /* @__PURE__ */ Q(0);
function en(e) {
  const t = W(e);
  return !pt() || !t.visualViewport ? ur : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function lr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== W(e) ? !1 : t;
}
function ue(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = ht(e);
  let s = Q(1);
  t && (r ? q(r) && (s = pe(r)) : s = pe(e));
  const a = lr(o, n, r) ? en(o) : Q(0);
  let c = (i.left + a.x) / s.x, u = (i.top + a.y) / s.y, l = i.width / s.x, f = i.height / s.y;
  if (o) {
    const v = W(o), d = r && q(r) ? W(r) : r;
    let m = v, p = st(m);
    for (; p && r && d !== m; ) {
      const g = pe(p), h = p.getBoundingClientRect(), x = K(p), E = h.left + (p.clientLeft + parseFloat(x.paddingLeft)) * g.x, O = h.top + (p.clientTop + parseFloat(x.paddingTop)) * g.y;
      c *= g.x, u *= g.y, l *= g.x, f *= g.y, c += E, u += O, m = W(p), p = st(m);
    }
  }
  return Fe({
    width: l,
    height: f,
    x: c,
    y: u
  });
}
function vt(e, t) {
  const n = Ke(e).scrollLeft;
  return t ? t.left + n : ue(X(e)).left + n;
}
function tn(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    vt(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function fr(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", s = X(r), a = t ? qe(t.floating) : !1;
  if (r === s || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Q(1);
  const l = Q(0), f = J(r);
  if ((f || !f && !o) && ((ye(r) !== "body" || Oe(s)) && (c = Ke(r)), J(r))) {
    const d = ue(r);
    u = pe(r), l.x = d.x + r.clientLeft, l.y = d.y + r.clientTop;
  }
  const v = s && !f && !o ? tn(s, c, !0) : Q(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + l.x + v.x,
    y: n.y * u.y - c.scrollTop * u.y + l.y + v.y
  };
}
function dr(e) {
  return Array.from(e.getClientRects());
}
function pr(e) {
  const t = X(e), n = Ke(e), r = e.ownerDocument.body, i = ae(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = ae(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + vt(e);
  const a = -n.scrollTop;
  return K(r).direction === "rtl" && (s += ae(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
function hr(e, t) {
  const n = W(e), r = X(e), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const u = pt();
    (!u || u && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
function vr(e, t) {
  const n = ue(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = J(e) ? pe(e) : Q(1), s = e.clientWidth * o.x, a = e.clientHeight * o.y, c = i * o.x, u = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function Ot(e, t, n) {
  let r;
  if (t === "viewport")
    r = hr(e, n);
  else if (t === "document")
    r = pr(X(e));
  else if (q(t))
    r = vr(t, n);
  else {
    const i = en(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Fe(r);
}
function nn(e, t) {
  const n = oe(e);
  return n === t || !q(n) || me(n) ? !1 : K(n).position === "fixed" || nn(n, t);
}
function mr(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ee(e, [], !1).filter((a) => q(a) && ye(a) !== "body"), i = null;
  const o = K(e).position === "fixed";
  let s = o ? oe(e) : e;
  for (; q(s) && !me(s); ) {
    const a = K(s), c = dt(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Oe(s) && !c && nn(e, s)) ? r = r.filter((l) => l !== s) : i = a, s = oe(s);
  }
  return t.set(e, r), r;
}
function gr(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? qe(t) ? [] : mr(t, this._c) : [].concat(n), r], a = s[0], c = s.reduce((u, l) => {
    const f = Ot(t, l, i);
    return u.top = ae(f.top, u.top), u.right = De(f.right, u.right), u.bottom = De(f.bottom, u.bottom), u.left = ae(f.left, u.left), u;
  }, Ot(t, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function br(e) {
  const {
    width: t,
    height: n
  } = Zt(e);
  return {
    width: t,
    height: n
  };
}
function yr(e, t, n) {
  const r = J(t), i = X(t), o = n === "fixed", s = ue(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Q(0);
  if (r || !r && !o)
    if ((ye(t) !== "body" || Oe(i)) && (a = Ke(t)), r) {
      const v = ue(t, !0, o, t);
      c.x = v.x + t.clientLeft, c.y = v.y + t.clientTop;
    } else i && (c.x = vt(i));
  const u = i && !r && !o ? tn(i, a) : Q(0), l = s.left + a.scrollLeft - c.x - u.x, f = s.top + a.scrollTop - c.y - u.y;
  return {
    x: l,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Ze(e) {
  return K(e).position === "static";
}
function At(e, t) {
  if (!J(e) || K(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return X(e) === n && (n = n.ownerDocument.body), n;
}
function rn(e, t) {
  const n = W(e);
  if (qe(e))
    return n;
  if (!J(e)) {
    let i = oe(e);
    for (; i && !me(i); ) {
      if (q(i) && !Ze(i))
        return i;
      i = oe(i);
    }
    return n;
  }
  let r = At(e, t);
  for (; r && ar(r) && Ze(r); )
    r = At(r, t);
  return r && me(r) && Ze(r) && !dt(r) ? n : r || cr(e) || n;
}
const wr = async function(e) {
  const t = this.getOffsetParent || rn, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: yr(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function xr(e) {
  return K(e).direction === "rtl";
}
const Sr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fr,
  getDocumentElement: X,
  getClippingRect: gr,
  getOffsetParent: rn,
  getElementRects: wr,
  getClientRects: dr,
  getDimensions: br,
  getScale: pe,
  isElement: q,
  isRTL: xr
};
function on(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Tr(e, t) {
  let n = null, r;
  const i = X(e);
  function o() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), o();
    const u = e.getBoundingClientRect(), {
      left: l,
      top: f,
      width: v,
      height: d
    } = u;
    if (a || t(), !v || !d)
      return;
    const m = _e(f), p = _e(i.clientWidth - (l + v)), g = _e(i.clientHeight - (f + d)), h = _e(l), E = {
      rootMargin: -m + "px " + -p + "px " + -g + "px " + -h + "px",
      threshold: ae(0, De(1, c)) || 1
    };
    let O = !0;
    function b(S) {
      const C = S[0].intersectionRatio;
      if (C !== c) {
        if (!O)
          return s();
        C ? s(!1, C) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !on(u, e.getBoundingClientRect()) && s(), O = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...E,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, E);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function Er(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = ht(e), l = i || o ? [...u ? Ee(u) : [], ...Ee(t)] : [];
  l.forEach((h) => {
    i && h.addEventListener("scroll", n, {
      passive: !0
    }), o && h.addEventListener("resize", n);
  });
  const f = u && a ? Tr(u, n) : null;
  let v = -1, d = null;
  s && (d = new ResizeObserver((h) => {
    let [x] = h;
    x && x.target === u && d && (d.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      var E;
      (E = d) == null || E.observe(t);
    })), n();
  }), u && !c && d.observe(u), d.observe(t));
  let m, p = c ? ue(e) : null;
  c && g();
  function g() {
    const h = ue(e);
    p && !on(p, h) && n(), p = h, m = requestAnimationFrame(g);
  }
  return n(), () => {
    var h;
    l.forEach((x) => {
      i && x.removeEventListener("scroll", n), o && x.removeEventListener("resize", n);
    }), f == null || f(), (h = d) == null || h.disconnect(), d = null, c && cancelAnimationFrame(m);
  };
}
const Cr = or, Pr = sr, Or = rr, Ar = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Sr,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return nr(e, t, {
    ...i,
    platform: o
  });
};
var Uo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Me = { exports: {} }, _r = Me.exports, kt;
function Lr() {
  return kt || (kt = 1, function(e) {
    (function(t, n) {
      e.exports ? e.exports = n() : t.log = n();
    })(_r, function() {
      var t = function() {
      }, n = "undefined", r = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], o = {}, s = null;
      function a(p, g) {
        var h = p[g];
        if (typeof h.bind == "function")
          return h.bind(p);
        try {
          return Function.prototype.bind.call(h, p);
        } catch {
          return function() {
            return Function.prototype.apply.apply(h, [p, arguments]);
          };
        }
      }
      function c() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function u(p) {
        return p === "debug" && (p = "log"), typeof console === n ? !1 : p === "trace" && r ? c : console[p] !== void 0 ? a(console, p) : console.log !== void 0 ? a(console, "log") : t;
      }
      function l() {
        for (var p = this.getLevel(), g = 0; g < i.length; g++) {
          var h = i[g];
          this[h] = g < p ? t : this.methodFactory(h, p, this.name);
        }
        if (this.log = this.debug, typeof console === n && p < this.levels.SILENT)
          return "No console available for logging";
      }
      function f(p) {
        return function() {
          typeof console !== n && (l.call(this), this[p].apply(this, arguments));
        };
      }
      function v(p, g, h) {
        return u(p) || f.apply(this, arguments);
      }
      function d(p, g) {
        var h = this, x, E, O, b = "loglevel";
        typeof p == "string" ? b += ":" + p : typeof p == "symbol" && (b = void 0);
        function S(T) {
          var _ = (i[T] || "silent").toUpperCase();
          if (!(typeof window === n || !b)) {
            try {
              window.localStorage[b] = _;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(b) + "=" + _ + ";";
            } catch {
            }
          }
        }
        function C() {
          var T;
          if (!(typeof window === n || !b)) {
            try {
              T = window.localStorage[b];
            } catch {
            }
            if (typeof T === n)
              try {
                var _ = window.document.cookie, Z = encodeURIComponent(b), G = _.indexOf(Z + "=");
                G !== -1 && (T = /^([^;]+)/.exec(
                  _.slice(G + Z.length + 1)
                )[1]);
              } catch {
              }
            return h.levels[T] === void 0 && (T = void 0), T;
          }
        }
        function $() {
          if (!(typeof window === n || !b)) {
            try {
              window.localStorage.removeItem(b);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(b) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function M(T) {
          var _ = T;
          if (typeof _ == "string" && h.levels[_.toUpperCase()] !== void 0 && (_ = h.levels[_.toUpperCase()]), typeof _ == "number" && _ >= 0 && _ <= h.levels.SILENT)
            return _;
          throw new TypeError("log.setLevel() called with invalid level: " + T);
        }
        h.name = p, h.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, h.methodFactory = g || v, h.getLevel = function() {
          return O ?? E ?? x;
        }, h.setLevel = function(T, _) {
          return O = M(T), _ !== !1 && S(O), l.call(h);
        }, h.setDefaultLevel = function(T) {
          E = M(T), C() || h.setLevel(T, !1);
        }, h.resetLevel = function() {
          O = null, $(), l.call(h);
        }, h.enableAll = function(T) {
          h.setLevel(h.levels.TRACE, T);
        }, h.disableAll = function(T) {
          h.setLevel(h.levels.SILENT, T);
        }, h.rebuild = function() {
          if (s !== h && (x = M(s.getLevel())), l.call(h), s === h)
            for (var T in o)
              o[T].rebuild();
        }, x = M(
          s ? s.getLevel() : "WARN"
        );
        var z = C();
        z != null && (O = M(z)), l.call(h);
      }
      s = new d(), s.getLogger = function(g) {
        if (typeof g != "symbol" && typeof g != "string" || g === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var h = o[g];
        return h || (h = o[g] = new d(
          g,
          s.methodFactory
        )), h;
      };
      var m = typeof window !== n ? window.log : void 0;
      return s.noConflict = function() {
        return typeof window !== n && window.log === s && (window.log = m), s;
      }, s.getLoggers = function() {
        return o;
      }, s.default = s, s;
    });
  }(Me)), Me.exports;
}
var Ir = Lr();
const Mr = /* @__PURE__ */ kr(Ir);
var at = function(e, t) {
  return at = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, at(e, t);
};
function te(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  at(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function Rr(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function a(l) {
      try {
        u(r.next(l));
      } catch (f) {
        s(f);
      }
    }
    function c(l) {
      try {
        u(r.throw(l));
      } catch (f) {
        s(f);
      }
    }
    function u(l) {
      l.done ? o(l.value) : i(l.value).then(a, c);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function sn(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return s.next = a(0), s.throw = a(1), s.return = a(2), typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (l) {
      u = [6, l], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function ge(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function le(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function be(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
function he(e) {
  return this instanceof he ? (this.v = e, this) : new he(e);
}
function Dr(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, o = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", s), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(d) {
    return function(m) {
      return Promise.resolve(m).then(d, f);
    };
  }
  function a(d, m) {
    r[d] && (i[d] = function(p) {
      return new Promise(function(g, h) {
        o.push([d, p, g, h]) > 1 || c(d, p);
      });
    }, m && (i[d] = m(i[d])));
  }
  function c(d, m) {
    try {
      u(r[d](m));
    } catch (p) {
      v(o[0][3], p);
    }
  }
  function u(d) {
    d.value instanceof he ? Promise.resolve(d.value.v).then(l, f) : v(o[0][2], d);
  }
  function l(d) {
    c("next", d);
  }
  function f(d) {
    c("throw", d);
  }
  function v(d, m) {
    d(m), o.shift(), o.length && c(o[0][0], o[0][1]);
  }
}
function $r(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof ge == "function" ? ge(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(s) {
      return new Promise(function(a, c) {
        s = e[o](s), i(a, c, s.done, s.value);
      });
    };
  }
  function i(o, s, a, c) {
    Promise.resolve(c).then(function(u) {
      o({ value: u, done: a });
    }, s);
  }
}
function P(e) {
  return typeof e == "function";
}
function mt(e) {
  var t = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var et = mt(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, i) {
      return i + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function Ue(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var Ae = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, r, i, o;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var a = ge(s), c = a.next(); !c.done; c = a.next()) {
              var u = c.value;
              u.remove(this);
            }
          } catch (p) {
            t = { error: p };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
        else
          s.remove(this);
      var l = this.initialTeardown;
      if (P(l))
        try {
          l();
        } catch (p) {
          o = p instanceof et ? p.errors : [p];
        }
      var f = this._finalizers;
      if (f) {
        this._finalizers = null;
        try {
          for (var v = ge(f), d = v.next(); !d.done; d = v.next()) {
            var m = d.value;
            try {
              _t(m);
            } catch (p) {
              o = o ?? [], p instanceof et ? o = be(be([], le(o)), le(p.errors)) : o.push(p);
            }
          }
        } catch (p) {
          r = { error: p };
        } finally {
          try {
            d && !d.done && (i = v.return) && i.call(v);
          } finally {
            if (r) throw r.error;
          }
        }
      }
      if (o)
        throw new et(o);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        _t(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && Ue(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && Ue(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), an = Ae.EMPTY;
function cn(e) {
  return e instanceof Ae || e && "closed" in e && P(e.remove) && P(e.add) && P(e.unsubscribe);
}
function _t(e) {
  P(e) ? e() : e.unsubscribe();
}
var Nr = {
  Promise: void 0
}, Fr = {
  setTimeout: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, be([e, t], le(n)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function un(e) {
  Fr.setTimeout(function() {
    throw e;
  });
}
function je() {
}
function Re(e) {
  e();
}
var gt = function(e) {
  te(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, cn(n) && n.add(r)) : r.destination = Wr, r;
  }
  return t.create = function(n, r, i) {
    return new Ce(n, r, i);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Ae), Ur = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (r) {
        Le(r);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (r) {
        Le(r);
      }
    else
      Le(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        Le(n);
      }
  }, e;
}(), Ce = function(e) {
  te(t, e);
  function t(n, r, i) {
    var o = e.call(this) || this, s;
    return P(n) || !n ? s = {
      next: n ?? void 0,
      error: r ?? void 0,
      complete: i ?? void 0
    } : s = n, o.destination = new Ur(s), o;
  }
  return t;
}(gt);
function Le(e) {
  un(e);
}
function jr(e) {
  throw e;
}
var Wr = {
  closed: !0,
  next: je,
  error: jr,
  complete: je
}, bt = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Ge(e) {
  return e;
}
function Br(e) {
  return e.length === 0 ? Ge : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(r, i) {
      return i(r);
    }, n);
  };
}
var k = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, r) {
    var i = this, o = Hr(t) ? t : new Ce(t, n, r);
    return Re(function() {
      var s = i, a = s.operator, c = s.source;
      o.add(a ? a.call(o, c) : c ? i._subscribe(o) : i._trySubscribe(o));
    }), o;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var r = this;
    return n = Lt(n), new n(function(i, o) {
      var s = new Ce({
        next: function(a) {
          try {
            t(a);
          } catch (c) {
            o(c), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
      r.subscribe(s);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[bt] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return Br(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Lt(t), new t(function(r, i) {
      var o;
      n.subscribe(function(s) {
        return o = s;
      }, function(s) {
        return i(s);
      }, function() {
        return r(o);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Lt(e) {
  var t;
  return (t = e ?? Nr.Promise) !== null && t !== void 0 ? t : Promise;
}
function Vr(e) {
  return e && P(e.next) && P(e.error) && P(e.complete);
}
function Hr(e) {
  return e && e instanceof gt || Vr(e) && cn(e);
}
function zr(e) {
  return P(e == null ? void 0 : e.lift);
}
function j(e) {
  return function(t) {
    if (zr(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (r) {
          this.error(r);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function F(e, t, n, r, i) {
  return new Yr(e, t, n, r, i);
}
var Yr = function(e) {
  te(t, e);
  function t(n, r, i, o, s, a) {
    var c = e.call(this, n) || this;
    return c.onFinalize = s, c.shouldUnsubscribe = a, c._next = r ? function(u) {
      try {
        r(u);
      } catch (l) {
        n.error(l);
      }
    } : e.prototype._next, c._error = o ? function(u) {
      try {
        o(u);
      } catch (l) {
        n.error(l);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, c._complete = i ? function() {
      try {
        i();
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, c;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var r = this.closed;
      e.prototype.unsubscribe.call(this), !r && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(gt), qr = mt(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), ee = function(e) {
  te(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return t.prototype.lift = function(n) {
    var r = new It(this, this);
    return r.operator = n, r;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new qr();
  }, t.prototype.next = function(n) {
    var r = this;
    Re(function() {
      var i, o;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var s = ge(r.currentObservers), a = s.next(); !a.done; a = s.next()) {
            var c = a.value;
            c.next(n);
          }
        } catch (u) {
          i = { error: u };
        } finally {
          try {
            a && !a.done && (o = s.return) && o.call(s);
          } finally {
            if (i) throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(n) {
    var r = this;
    Re(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var i = r.observers; i.length; )
          i.shift().error(n);
      }
    });
  }, t.prototype.complete = function() {
    var n = this;
    Re(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, n);
  }, t.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, t.prototype._innerSubscribe = function(n) {
    var r = this, i = this, o = i.hasError, s = i.isStopped, a = i.observers;
    return o || s ? an : (this.currentObservers = null, a.push(n), new Ae(function() {
      r.currentObservers = null, Ue(a, n);
    }));
  }, t.prototype._checkFinalizedStatuses = function(n) {
    var r = this, i = r.hasError, o = r.thrownError, s = r.isStopped;
    i ? n.error(o) : s && n.complete();
  }, t.prototype.asObservable = function() {
    var n = new k();
    return n.source = this, n;
  }, t.create = function(n, r) {
    return new It(n, r);
  }, t;
}(k), It = function(e) {
  te(t, e);
  function t(n, r) {
    var i = e.call(this) || this;
    return i.destination = n, i.source = r, i;
  }
  return t.prototype.next = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || i === void 0 || i.call(r, n);
  }, t.prototype.error = function(n) {
    var r, i;
    (i = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || i === void 0 || i.call(r, n);
  }, t.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, t.prototype._subscribe = function(n) {
    var r, i;
    return (i = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && i !== void 0 ? i : an;
  }, t;
}(ee), ln = function(e) {
  te(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r._value = n, r;
  }
  return Object.defineProperty(t.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._subscribe = function(n) {
    var r = e.prototype._subscribe.call(this, n);
    return !r.closed && n.next(this._value), r;
  }, t.prototype.getValue = function() {
    var n = this, r = n.hasError, i = n.thrownError, o = n._value;
    if (r)
      throw i;
    return this._throwIfClosed(), o;
  }, t.prototype.next = function(n) {
    e.prototype.next.call(this, this._value = n);
  }, t;
}(ee), Kr = {
  now: function() {
    return Date.now();
  }
}, Gr = function(e) {
  te(t, e);
  function t(n, r) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(n, r) {
    return this;
  }, t;
}(Ae), Mt = {
  setInterval: function(e, t) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setInterval.apply(void 0, be([e, t], le(n)));
  },
  clearInterval: function(e) {
    return clearInterval(e);
  },
  delegate: void 0
}, Qr = function(e) {
  te(t, e);
  function t(n, r) {
    var i = e.call(this, n, r) || this;
    return i.scheduler = n, i.work = r, i.pending = !1, i;
  }
  return t.prototype.schedule = function(n, r) {
    var i;
    if (r === void 0 && (r = 0), this.closed)
      return this;
    this.state = n;
    var o = this.id, s = this.scheduler;
    return o != null && (this.id = this.recycleAsyncId(s, o, r)), this.pending = !0, this.delay = r, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(s, this.id, r), this;
  }, t.prototype.requestAsyncId = function(n, r, i) {
    return i === void 0 && (i = 0), Mt.setInterval(n.flush.bind(n, this), i);
  }, t.prototype.recycleAsyncId = function(n, r, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return r;
    r != null && Mt.clearInterval(r);
  }, t.prototype.execute = function(n, r) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(n, r);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(n, r) {
    var i = !1, o;
    try {
      this.work(n);
    } catch (s) {
      i = !0, o = s || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), o;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, r = n.id, i = n.scheduler, o = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Ue(o, this), r != null && (this.id = this.recycleAsyncId(i, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(Gr), Rt = function() {
  function e(t, n) {
    n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
  }
  return e.prototype.schedule = function(t, n, r) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, t).schedule(r, n);
  }, e.now = Kr.now, e;
}(), Jr = function(e) {
  te(t, e);
  function t(n, r) {
    r === void 0 && (r = Rt.now);
    var i = e.call(this, n, r) || this;
    return i.actions = [], i._active = !1, i;
  }
  return t.prototype.flush = function(n) {
    var r = this.actions;
    if (this._active) {
      r.push(n);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = n.execute(n.state, n.delay))
        break;
    while (n = r.shift());
    if (this._active = !1, i) {
      for (; n = r.shift(); )
        n.unsubscribe();
      throw i;
    }
  }, t;
}(Rt), Xr = new Jr(Qr);
function Zr(e) {
  return e && P(e.schedule);
}
function ei(e) {
  return e[e.length - 1];
}
function yt(e) {
  return Zr(ei(e)) ? e.pop() : void 0;
}
var wt = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function fn(e) {
  return P(e == null ? void 0 : e.then);
}
function dn(e) {
  return P(e[bt]);
}
function pn(e) {
  return Symbol.asyncIterator && P(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function hn(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function ti() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var vn = ti();
function mn(e) {
  return P(e == null ? void 0 : e[vn]);
}
function gn(e) {
  return Dr(this, arguments, function() {
    var n, r, i, o;
    return sn(this, function(s) {
      switch (s.label) {
        case 0:
          n = e.getReader(), s.label = 1;
        case 1:
          s.trys.push([1, , 9, 10]), s.label = 2;
        case 2:
          return [4, he(n.read())];
        case 3:
          return r = s.sent(), i = r.value, o = r.done, o ? [4, he(void 0)] : [3, 5];
        case 4:
          return [2, s.sent()];
        case 5:
          return [4, he(i)];
        case 6:
          return [4, s.sent()];
        case 7:
          return s.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function bn(e) {
  return P(e == null ? void 0 : e.getReader);
}
function H(e) {
  if (e instanceof k)
    return e;
  if (e != null) {
    if (dn(e))
      return ni(e);
    if (wt(e))
      return ri(e);
    if (fn(e))
      return ii(e);
    if (pn(e))
      return yn(e);
    if (mn(e))
      return oi(e);
    if (bn(e))
      return si(e);
  }
  throw hn(e);
}
function ni(e) {
  return new k(function(t) {
    var n = e[bt]();
    if (P(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function ri(e) {
  return new k(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function ii(e) {
  return new k(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, un);
  });
}
function oi(e) {
  return new k(function(t) {
    var n, r;
    try {
      for (var i = ge(e), o = i.next(); !o.done; o = i.next()) {
        var s = o.value;
        if (t.next(s), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        o && !o.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    t.complete();
  });
}
function yn(e) {
  return new k(function(t) {
    ai(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function si(e) {
  return yn(gn(e));
}
function ai(e, t) {
  var n, r, i, o;
  return Rr(this, void 0, void 0, function() {
    var s, a;
    return sn(this, function(c) {
      switch (c.label) {
        case 0:
          c.trys.push([0, 5, 6, 11]), n = $r(e), c.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (r = c.sent(), !!r.done) return [3, 4];
          if (s = r.value, t.next(s), t.closed)
            return [2];
          c.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = c.sent(), i = { error: a }, [3, 11];
        case 6:
          return c.trys.push([6, , 9, 10]), r && !r.done && (o = n.return) ? [4, o.call(n)] : [3, 8];
        case 7:
          c.sent(), c.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i) throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function ie(e, t, n, r, i) {
  r === void 0 && (r = 0), i === void 0 && (i = !1);
  var o = t.schedule(function() {
    n(), i ? e.add(this.schedule(null, r)) : this.unsubscribe();
  }, r);
  if (e.add(o), !i)
    return o;
}
function wn(e, t) {
  return t === void 0 && (t = 0), j(function(n, r) {
    n.subscribe(F(r, function(i) {
      return ie(r, e, function() {
        return r.next(i);
      }, t);
    }, function() {
      return ie(r, e, function() {
        return r.complete();
      }, t);
    }, function(i) {
      return ie(r, e, function() {
        return r.error(i);
      }, t);
    }));
  });
}
function xn(e, t) {
  return t === void 0 && (t = 0), j(function(n, r) {
    r.add(e.schedule(function() {
      return n.subscribe(r);
    }, t));
  });
}
function ci(e, t) {
  return H(e).pipe(xn(t), wn(t));
}
function ui(e, t) {
  return H(e).pipe(xn(t), wn(t));
}
function li(e, t) {
  return new k(function(n) {
    var r = 0;
    return t.schedule(function() {
      r === e.length ? n.complete() : (n.next(e[r++]), n.closed || this.schedule());
    });
  });
}
function fi(e, t) {
  return new k(function(n) {
    var r;
    return ie(n, t, function() {
      r = e[vn](), ie(n, t, function() {
        var i, o, s;
        try {
          i = r.next(), o = i.value, s = i.done;
        } catch (a) {
          n.error(a);
          return;
        }
        s ? n.complete() : n.next(o);
      }, 0, !0);
    }), function() {
      return P(r == null ? void 0 : r.return) && r.return();
    };
  });
}
function Sn(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new k(function(n) {
    ie(n, t, function() {
      var r = e[Symbol.asyncIterator]();
      ie(n, t, function() {
        r.next().then(function(i) {
          i.done ? n.complete() : n.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function di(e, t) {
  return Sn(gn(e), t);
}
function pi(e, t) {
  if (e != null) {
    if (dn(e))
      return ci(e, t);
    if (wt(e))
      return li(e, t);
    if (fn(e))
      return ui(e, t);
    if (pn(e))
      return Sn(e, t);
    if (mn(e))
      return fi(e, t);
    if (bn(e))
      return di(e, t);
  }
  throw hn(e);
}
function Qe(e, t) {
  return t ? pi(e, t) : H(e);
}
function Dt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = yt(e);
  return Qe(e, n);
}
function hi(e) {
  return e instanceof Date && !isNaN(e);
}
var vi = mt(function(e) {
  return function(n) {
    n === void 0 && (n = null), e(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = n;
  };
});
function mi(e, t) {
  var n = hi(e) ? { first: e } : typeof e == "number" ? { each: e } : e, r = n.first, i = n.each, o = n.with, s = o === void 0 ? gi : o, a = n.scheduler, c = a === void 0 ? Xr : a, u = n.meta, l = u === void 0 ? null : u;
  if (r == null && i == null)
    throw new TypeError("No timeout provided.");
  return j(function(f, v) {
    var d, m, p = null, g = 0, h = function(x) {
      m = ie(v, c, function() {
        try {
          d.unsubscribe(), H(s({
            meta: l,
            lastValue: p,
            seen: g
          })).subscribe(v);
        } catch (E) {
          v.error(E);
        }
      }, x);
    };
    d = f.subscribe(F(v, function(x) {
      m == null || m.unsubscribe(), g++, v.next(p = x), i > 0 && h(i);
    }, void 0, void 0, function() {
      m != null && m.closed || m == null || m.unsubscribe(), p = null;
    })), !g && h(r != null ? typeof r == "number" ? r : +r - c.now() : i);
  });
}
function gi(e) {
  throw new vi(e);
}
function A(e, t) {
  return j(function(n, r) {
    var i = 0;
    n.subscribe(F(r, function(o) {
      r.next(e.call(t, o, i++));
    }));
  });
}
var bi = Array.isArray;
function yi(e, t) {
  return bi(t) ? e.apply(void 0, be([], le(t))) : e(t);
}
function wi(e) {
  return A(function(t) {
    return yi(e, t);
  });
}
function xi(e, t, n, r, i, o, s, a) {
  var c = [], u = 0, l = 0, f = !1, v = function() {
    f && !c.length && !u && t.complete();
  }, d = function(p) {
    return u < r ? m(p) : c.push(p);
  }, m = function(p) {
    u++;
    var g = !1;
    H(n(p, l++)).subscribe(F(t, function(h) {
      t.next(h);
    }, function() {
      g = !0;
    }, void 0, function() {
      if (g)
        try {
          u--;
          for (var h = function() {
            var x = c.shift();
            s || m(x);
          }; c.length && u < r; )
            h();
          v();
        } catch (x) {
          t.error(x);
        }
    }));
  };
  return e.subscribe(F(t, d, function() {
    f = !0, v();
  })), function() {
  };
}
function xt(e, t, n) {
  return n === void 0 && (n = 1 / 0), P(t) ? xt(function(r, i) {
    return A(function(o, s) {
      return t(r, o, i, s);
    })(H(e(r, i)));
  }, n) : (typeof t == "number" && (n = t), j(function(r, i) {
    return xi(r, i, e, n);
  }));
}
function Si(e) {
  return xt(Ge, e);
}
function Ti() {
  return Si(1);
}
function We() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return Ti()(Qe(e, yt(e)));
}
var Ei = ["addListener", "removeListener"], Ci = ["addEventListener", "removeEventListener"], Pi = ["on", "off"];
function ct(e, t, n, r) {
  if (P(n) && (r = n, n = void 0), r)
    return ct(e, t, n).pipe(wi(r));
  var i = le(ki(e) ? Ci.map(function(a) {
    return function(c) {
      return e[a](t, c, n);
    };
  }) : Oi(e) ? Ei.map($t(e, t)) : Ai(e) ? Pi.map($t(e, t)) : [], 2), o = i[0], s = i[1];
  if (!o && wt(e))
    return xt(function(a) {
      return ct(a, t, n);
    })(H(e));
  if (!o)
    throw new TypeError("Invalid event target");
  return new k(function(a) {
    var c = function() {
      for (var u = [], l = 0; l < arguments.length; l++)
        u[l] = arguments[l];
      return a.next(1 < u.length ? u : u[0]);
    };
    return o(c), function() {
      return s(c);
    };
  });
}
function $t(e, t) {
  return function(n) {
    return function(r) {
      return e[n](t, r);
    };
  };
}
function Oi(e) {
  return P(e.addListener) && P(e.removeListener);
}
function Ai(e) {
  return P(e.on) && P(e.off);
}
function ki(e) {
  return P(e.addEventListener) && P(e.removeEventListener);
}
function Je(e, t) {
  return j(function(n, r) {
    var i = 0;
    n.subscribe(F(r, function(o) {
      return e.call(t, o, i++) && r.next(o);
    }));
  });
}
function _i(e, t, n, r, i) {
  return function(o, s) {
    var a = n, c = t, u = 0;
    o.subscribe(F(s, function(l) {
      var f = u++;
      c = a ? e(c, l, f) : (a = !0, l), s.next(c);
    }, i));
  };
}
function Li(e, t) {
  return t === void 0 && (t = Ge), e = e ?? Ii, j(function(n, r) {
    var i, o = !0;
    n.subscribe(F(r, function(s) {
      var a = t(s);
      (o || !e(i, a)) && (o = !1, i = a, r.next(s));
    }));
  });
}
function Ii(e, t) {
  return e === t;
}
function ut(e, t) {
  return j(_i(e, t, arguments.length >= 2, !0));
}
function Mi(e) {
  e === void 0 && (e = {});
  var t = e.connector, n = t === void 0 ? function() {
    return new ee();
  } : t, r = e.resetOnError, i = r === void 0 ? !0 : r, o = e.resetOnComplete, s = o === void 0 ? !0 : o, a = e.resetOnRefCountZero, c = a === void 0 ? !0 : a;
  return function(u) {
    var l, f, v, d = 0, m = !1, p = !1, g = function() {
      f == null || f.unsubscribe(), f = void 0;
    }, h = function() {
      g(), l = v = void 0, m = p = !1;
    }, x = function() {
      var E = l;
      h(), E == null || E.unsubscribe();
    };
    return j(function(E, O) {
      d++, !p && !m && g();
      var b = v = v ?? n();
      O.add(function() {
        d--, d === 0 && !p && !m && (f = tt(x, c));
      }), b.subscribe(O), !l && d > 0 && (l = new Ce({
        next: function(S) {
          return b.next(S);
        },
        error: function(S) {
          p = !0, g(), f = tt(h, i, S), b.error(S);
        },
        complete: function() {
          m = !0, g(), f = tt(h, s), b.complete();
        }
      }), H(E).subscribe(l));
    })(u);
  };
}
function tt(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  if (t === !0) {
    e();
    return;
  }
  if (t !== !1) {
    var i = new Ce({
      next: function() {
        i.unsubscribe(), e();
      }
    });
    return H(t.apply(void 0, be([], le(n)))).subscribe(i);
  }
}
function Ri(e) {
  return j(function(t, n) {
    var r = !1, i = F(n, function() {
      i == null || i.unsubscribe(), r = !0;
    }, je);
    H(e).subscribe(i), t.subscribe(F(n, function(o) {
      return r && n.next(o);
    }));
  });
}
function D() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = yt(e);
  return j(function(r, i) {
    (n ? We(e, r, n) : We(e, r)).subscribe(i);
  });
}
function Tn(e, t) {
  return j(function(n, r) {
    var i = null, o = 0, s = !1, a = function() {
      return s && !i && r.complete();
    };
    n.subscribe(F(r, function(c) {
      i == null || i.unsubscribe();
      var u = 0, l = o++;
      H(e(c, l)).subscribe(i = F(r, function(f) {
        return r.next(t ? t(c, f, l, u++) : f);
      }, function() {
        i = null, a();
      }));
    }, function() {
      s = !0, a();
    }));
  });
}
function Nt(e) {
  return j(function(t, n) {
    H(e).subscribe(F(n, function() {
      return n.complete();
    }, je)), !n.closed && t.subscribe(n);
  });
}
function Di(e, t, n) {
  var r = P(e) || t || n ? { next: e, error: t, complete: n } : e;
  return r ? j(function(i, o) {
    var s;
    (s = r.subscribe) === null || s === void 0 || s.call(r);
    var a = !0;
    i.subscribe(F(o, function(c) {
      var u;
      (u = r.next) === null || u === void 0 || u.call(r, c), o.next(c);
    }, function() {
      var c;
      a = !1, (c = r.complete) === null || c === void 0 || c.call(r), o.complete();
    }, function(c) {
      var u;
      a = !1, (u = r.error) === null || u === void 0 || u.call(r, c), o.error(c);
    }, function() {
      var c, u;
      a && ((c = r.unsubscribe) === null || c === void 0 || c.call(r)), (u = r.finalize) === null || u === void 0 || u.call(r);
    }));
  }) : Ge;
}
var $i = Object.defineProperty, Ni = Object.defineProperties, Fi = Object.getOwnPropertyDescriptors, Ft = Object.getOwnPropertySymbols, Ui = Object.prototype.hasOwnProperty, ji = Object.prototype.propertyIsEnumerable, Ut = (e, t, n) => t in e ? $i(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Y = (e, t) => {
  for (var n in t || (t = {}))
    Ui.call(t, n) && Ut(e, n, t[n]);
  if (Ft)
    for (var n of Ft(t))
      ji.call(t, n) && Ut(e, n, t[n]);
  return e;
}, se = (e, t) => Ni(e, Fi(t)), V = (e, t, n) => new Promise((r, i) => {
  var o = (c) => {
    try {
      a(n.next(c));
    } catch (u) {
      i(u);
    }
  }, s = (c) => {
    try {
      a(n.throw(c));
    } catch (u) {
      i(u);
    }
  }, a = (c) => c.done ? r(c.value) : Promise.resolve(c.value).then(o, s);
  a((n = n.apply(e, t)).next());
}), En = "lk";
function B(e) {
  return typeof e > "u" ? !1 : Wi(e) || Bi(e);
}
function Wi(e) {
  var t;
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && e.hasOwnProperty("track") && typeof ((t = e.publication) == null ? void 0 : t.track) < "u" : !1;
}
function Bi(e) {
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && e.hasOwnProperty("publication") && typeof e.publication < "u" : !1;
}
function Pe(e) {
  return e ? e.hasOwnProperty("participant") && e.hasOwnProperty("source") && typeof e.publication > "u" : !1;
}
function N(e) {
  if (typeof e == "string" || typeof e == "number")
    return `${e}`;
  if (Pe(e))
    return `${e.participant.identity}_${e.source}_placeholder`;
  if (B(e))
    return `${e.participant.identity}_${e.publication.source}_${e.publication.trackSid}`;
  throw new Error(`Can't generate a id for the given track reference: ${e}`);
}
function jo(e, t) {
  return e === void 0 || t === void 0 ? !1 : B(e) && B(t) ? e.publication.trackSid === t.publication.trackSid : N(e) === N(t);
}
function Wo(e, t) {
  return typeof t > "u" ? !1 : B(e) ? t.some(
    (n) => n.participant.identity === e.participant.identity && B(n) && n.publication.trackSid === e.publication.trackSid
  ) : Pe(e) ? t.some(
    (n) => n.participant.identity === e.participant.identity && Pe(n) && n.source === e.source
  ) : !1;
}
function Vi(e, t) {
  return Pe(e) && B(t) && t.participant.identity === e.participant.identity && t.source === e.source;
}
function Bo() {
  const e = document.createElement("p");
  e.style.width = "100%", e.style.height = "200px";
  const t = document.createElement("div");
  t.style.position = "absolute", t.style.top = "0px", t.style.left = "0px", t.style.visibility = "hidden", t.style.width = "200px", t.style.height = "150px", t.style.overflow = "hidden", t.appendChild(e), document.body.appendChild(t);
  const n = e.offsetWidth;
  t.style.overflow = "scroll";
  let r = e.offsetWidth;
  return n === r && (r = t.clientWidth), document.body.removeChild(t), n - r;
}
function Vo() {
  return typeof document < "u";
}
function Hi(e) {
  e = Y({}, e);
  const t = "(?:(?:[a-z]+:)?//)?", n = "(?:\\S+(?::\\S*)?@)?", r = new RegExp(
    "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}",
    "g"
  ).source, u = `(?:${t}|www\\.)${n}(?:localhost|${r}|(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#][^\\s"]*)?`;
  return e.exact ? new RegExp(`(?:^${u}$)`, "i") : new RegExp(u, "ig");
}
var jt = "[^\\.\\s@:](?:[^\\s@:]*[^\\s@:\\.])?@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)*";
function zi({ exact: e } = {}) {
  return e ? new RegExp(`^${jt}$`) : new RegExp(jt, "g");
}
function Ho(e, t, n) {
  return Er(e, t, () => V(this, null, function* () {
    const { x: i, y: o } = yield Ar(e, t, {
      placement: "top",
      middleware: [Cr(6), Or(), Pr({ padding: 5 })]
    });
    n == null || n(i, o);
  }));
}
function zo(e, t) {
  return !e.contains(t.target);
}
var Yo = () => ({
  email: zi(),
  url: Hi({})
});
function qo(e, t) {
  const n = Object.entries(t).map(
    ([o, s], a) => Array.from(e.matchAll(s)).map(({ index: c, 0: u }) => ({
      type: o,
      weight: a,
      content: u,
      index: c ?? 0
    }))
  ).flat().sort((o, s) => {
    const a = o.index - s.index;
    return a !== 0 ? a : o.weight - s.weight;
  }).filter(({ index: o }, s, a) => {
    if (s === 0) return !0;
    const c = a[s - 1];
    return c.index + c.content.length <= o;
  }), r = [];
  let i = 0;
  for (const { type: o, content: s, index: a } of n)
    a > i && r.push(e.substring(i, a)), r.push({ type: o, content: s }), i = a + s.length;
  return e.length > i && r.push(e.substring(i)), r;
}
var Yi = [
  y.ConnectionStateChanged,
  y.RoomMetadataChanged,
  y.ActiveSpeakersChanged,
  y.ConnectionQualityChanged,
  y.ParticipantConnected,
  y.ParticipantDisconnected,
  y.ParticipantPermissionsChanged,
  y.ParticipantMetadataChanged,
  y.ParticipantNameChanged,
  y.ParticipantAttributesChanged,
  y.TrackMuted,
  y.TrackUnmuted,
  y.TrackPublished,
  y.TrackUnpublished,
  y.TrackStreamStateChanged,
  y.TrackSubscriptionFailed,
  y.TrackSubscriptionPermissionChanged,
  y.TrackSubscriptionStatusChanged
], Cn = [
  ...Yi,
  y.LocalTrackPublished,
  y.LocalTrackUnpublished
], qi = [
  w.TrackPublished,
  w.TrackUnpublished,
  w.TrackMuted,
  w.TrackUnmuted,
  w.TrackStreamStateChanged,
  w.TrackSubscribed,
  w.TrackUnsubscribed,
  w.TrackSubscriptionPermissionChanged,
  w.TrackSubscriptionFailed,
  w.LocalTrackPublished,
  w.LocalTrackUnpublished
], Ki = [
  w.ConnectionQualityChanged,
  w.IsSpeakingChanged,
  w.ParticipantMetadataChanged,
  w.ParticipantPermissionsChanged,
  w.TrackMuted,
  w.TrackUnmuted,
  w.TrackPublished,
  w.TrackUnpublished,
  w.TrackStreamStateChanged,
  w.TrackSubscriptionFailed,
  w.TrackSubscriptionPermissionChanged,
  w.TrackSubscriptionStatusChanged
], Pn = [
  ...Ki,
  w.LocalTrackPublished,
  w.LocalTrackUnpublished
], L = Mr.getLogger("lk-components-js");
L.setDefaultLevel("WARN");
function Ko(e, t = {}) {
  var n;
  L.setLevel(e), Hn((n = t.liveKitClientLogLevel) != null ? n : e);
}
function Go(e, t = {}) {
  var n;
  const r = L.methodFactory;
  L.methodFactory = (i, o, s) => {
    const a = r(i, o, s), c = St[i], u = c >= o && c < St.silent;
    return (l, f) => {
      f ? a(l, f) : a(l), u && e(c, l, f);
    };
  }, L.setLevel(L.getLevel()), zn((n = t.liveKitClientLogExtension) != null ? n : e);
}
var Qo = [
  {
    columns: 1,
    rows: 1
  },
  {
    columns: 1,
    rows: 2,
    orientation: "portrait"
  },
  {
    columns: 2,
    rows: 1,
    orientation: "landscape"
  },
  {
    columns: 2,
    rows: 2,
    minWidth: 560
  },
  {
    columns: 3,
    rows: 3,
    minWidth: 700
  },
  {
    columns: 4,
    rows: 4,
    minWidth: 960
  },
  {
    columns: 5,
    rows: 5,
    minWidth: 1100
  }
];
function Gi(e, t, n, r) {
  if (e.length < 1)
    throw new Error("At least one grid layout definition must be provided.");
  const i = Qi(e);
  if (n <= 0 || r <= 0)
    return i[0];
  let o = 0;
  const s = n / r > 1 ? "landscape" : "portrait";
  let a = i.find((c, u, l) => {
    o = u;
    const f = l.findIndex((v, d) => {
      const m = !v.orientation || v.orientation === s, p = d > u, g = v.maxTiles === c.maxTiles;
      return p && g && m;
    }) !== -1;
    return c.maxTiles >= t && !f;
  });
  if (a === void 0)
    if (a = i[i.length - 1], a)
      L.warn(
        `No layout found for: participantCount: ${t}, width/height: ${n}/${r} fallback to biggest available layout (${a}).`
      );
    else
      throw new Error("No layout or fallback layout found.");
  if ((n < a.minWidth || r < a.minHeight) && o > 0) {
    const c = i[o - 1];
    a = Gi(
      i.slice(0, o),
      c.maxTiles,
      n,
      r
    );
  }
  return a;
}
function Qi(e) {
  return [...e].map((t) => {
    var n, r;
    return {
      name: `${t.columns}x${t.rows}`,
      columns: t.columns,
      rows: t.rows,
      maxTiles: t.columns * t.rows,
      minWidth: (n = t.minWidth) != null ? n : 0,
      minHeight: (r = t.minHeight) != null ? r : 0,
      orientation: t.orientation
    };
  }).sort((t, n) => t.maxTiles !== n.maxTiles ? t.maxTiles - n.maxTiles : t.minWidth !== 0 || n.minWidth !== 0 ? t.minWidth - n.minWidth : t.minHeight !== 0 || n.minHeight !== 0 ? t.minHeight - n.minHeight : 0);
}
function Jo() {
  return typeof navigator < "u" && navigator.mediaDevices && !!navigator.mediaDevices.getDisplayMedia;
}
function Xo(e, t) {
  var n;
  return se(Y({}, e), {
    receivedAtMediaTimestamp: (n = t.rtpTimestamp) != null ? n : 0,
    receivedAt: t.timestamp
  });
}
function Zo(e, t, n) {
  return [...e, ...t].reduceRight((r, i) => (r.find((o) => o.id === i.id) || r.unshift(i), r), []).slice(0 - n);
}
var Ji = /* @__PURE__ */ ((e) => (e.AgentState = "lk.agent.state", e.PublishOnBehalf = "lk.publish_on_behalf", e.TranscriptionFinal = "lk.transcription_final", e.TranscriptionSegmentId = "lk.segment_id", e.TranscribedTrackId = "lk.transcribed_track_id", e))(Ji || {}), On = [], An = {
  showChat: !1,
  unreadMessages: 0,
  showSettings: !1
};
function Xi(e) {
  return typeof e == "object";
}
function es(e) {
  return Array.isArray(e) && e.filter(Xi).length > 0;
}
function kn(e, t) {
  return t.audioLevel - e.audioLevel;
}
function _n(e, t) {
  return e.isSpeaking === t.isSpeaking ? 0 : e.isSpeaking ? -1 : 1;
}
function Ln(e, t) {
  var n, r, i, o;
  return e.lastSpokeAt !== void 0 || t.lastSpokeAt !== void 0 ? ((r = (n = t.lastSpokeAt) == null ? void 0 : n.getTime()) != null ? r : 0) - ((o = (i = e.lastSpokeAt) == null ? void 0 : i.getTime()) != null ? o : 0) : 0;
}
function Be(e, t) {
  var n, r, i, o;
  return ((r = (n = e.joinedAt) == null ? void 0 : n.getTime()) != null ? r : 0) - ((o = (i = t.joinedAt) == null ? void 0 : i.getTime()) != null ? o : 0);
}
function Zi(e, t) {
  return B(e) ? B(t) ? 0 : -1 : B(t) ? 1 : 0;
}
function eo(e, t) {
  const n = e.participant.isCameraEnabled, r = t.participant.isCameraEnabled;
  return n !== r ? n ? -1 : 1 : 0;
}
function ts(e) {
  const t = [], n = [], r = [], i = [];
  e.forEach((a) => {
    a.participant.isLocal && a.source === R.Source.Camera ? t.push(a) : a.source === R.Source.ScreenShare ? n.push(a) : a.source === R.Source.Camera ? r.push(a) : i.push(a);
  });
  const o = to(n), s = no(r);
  return [...t, ...o, ...s, ...i];
}
function to(e) {
  const t = [], n = [];
  return e.forEach((i) => {
    i.participant.isLocal ? t.push(i) : n.push(i);
  }), t.sort((i, o) => Be(i.participant, o.participant)), n.sort((i, o) => Be(i.participant, o.participant)), [...n, ...t];
}
function no(e) {
  const t = [], n = [];
  return e.forEach((r) => {
    r.participant.isLocal ? t.push(r) : n.push(r);
  }), n.sort((r, i) => r.participant.isSpeaking && i.participant.isSpeaking ? kn(r.participant, i.participant) : r.participant.isSpeaking !== i.participant.isSpeaking ? _n(r.participant, i.participant) : r.participant.lastSpokeAt !== i.participant.lastSpokeAt ? Ln(r.participant, i.participant) : B(r) !== B(i) ? Zi(r, i) : r.participant.isCameraEnabled !== i.participant.isCameraEnabled ? eo(r, i) : Be(r.participant, i.participant)), [...t, ...n];
}
function ns(e) {
  const t = [...e];
  t.sort((r, i) => {
    if (r.isSpeaking && i.isSpeaking)
      return kn(r, i);
    if (r.isSpeaking !== i.isSpeaking)
      return _n(r, i);
    if (r.lastSpokeAt !== i.lastSpokeAt)
      return Ln(r, i);
    const o = r.videoTrackPublications.size > 0, s = i.videoTrackPublications.size > 0;
    return o !== s ? o ? -1 : 1 : Be(r, i);
  });
  const n = t.find((r) => r.isLocal);
  if (n) {
    const r = t.indexOf(n);
    r >= 0 && (t.splice(r, 1), t.length > 0 ? t.splice(0, 0, n) : t.push(n));
  }
  return t;
}
function ro(e, t) {
  return e.reduce(
    (n, r, i) => i % t === 0 ? [...n, [r]] : [...n.slice(0, -1), [...n.slice(-1)[0], r]],
    []
  );
}
function Wt(e, t) {
  const n = Math.max(e.length, t.length);
  return new Array(n).fill([]).map((r, i) => [e[i], t[i]]);
}
function Ve(e, t, n) {
  return e.filter((r) => !t.map((i) => n(i)).includes(n(r)));
}
function lt(e) {
  return e.map((t) => typeof t == "string" || typeof t == "number" ? `${t}` : N(t));
}
function io(e, t) {
  return {
    dropped: Ve(e, t, N),
    added: Ve(t, e, N)
  };
}
function oo(e) {
  return e.added.length !== 0 || e.dropped.length !== 0;
}
function ft(e, t) {
  const n = t.findIndex(
    (r) => N(r) === N(e)
  );
  if (n === -1)
    throw new Error(
      `Element not part of the array: ${N(
        e
      )} not in ${lt(t)}`
    );
  return n;
}
function so(e, t, n) {
  const r = ft(e, n), i = ft(t, n);
  return n.splice(r, 1, t), n.splice(i, 1, e), n;
}
function ao(e, t) {
  const n = ft(e, t);
  return t.splice(n, 1), t;
}
function co(e, t) {
  return [...t, e];
}
function nt(e, t) {
  return ro(e, t);
}
function rs(e, t, n) {
  let r = uo(e, t);
  if (r.length < t.length) {
    const s = Ve(t, r, N);
    r = [...r, ...s];
  }
  const i = nt(r, n), o = nt(t, n);
  if (Wt(i, o).forEach(([s, a], c) => {
    if (s && a) {
      const u = nt(r, n)[c], l = io(u, a);
      oo(l) && (L.debug(
        `Detected visual changes on page: ${c}, current: ${lt(
          s
        )}, next: ${lt(a)}`,
        { changes: l }
      ), l.added.length === l.dropped.length && Wt(l.added, l.dropped).forEach(([f, v]) => {
        if (f && v)
          r = so(f, v, r);
        else
          throw new Error(
            `For a swap action we need a addition and a removal one is missing: ${f}, ${v}`
          );
      }), l.added.length === 0 && l.dropped.length > 0 && l.dropped.forEach((f) => {
        r = ao(f, r);
      }), l.added.length > 0 && l.dropped.length === 0 && l.added.forEach((f) => {
        r = co(f, r);
      }));
    }
  }), r.length > t.length) {
    const s = Ve(r, t, N);
    r = r.filter(
      (a) => !s.map(N).includes(N(a))
    );
  }
  return r;
}
function uo(e, t) {
  return e.map((n) => {
    const r = t.find(
      (i) => (
        // If the IDs match or ..
        N(n) === N(i) || // ... if the current item is a placeholder and the new item is the track reference can replace it.
        typeof n != "number" && Pe(n) && B(i) && Vi(n, i)
      )
    );
    return r ?? n;
  });
}
function U(e) {
  return `${En}-${e}`;
}
function is(e) {
  const t = Bt(e), n = In(e.participant).pipe(
    A(() => Bt(e)),
    D(t)
  );
  return { className: U(
    e.source === R.Source.Camera || e.source === R.Source.ScreenShare ? "participant-media-video" : "participant-media-audio"
  ), trackObserver: n };
}
function Bt(e) {
  if (B(e))
    return e.publication;
  {
    const { source: t, name: n, participant: r } = e;
    if (t && n)
      return r.getTrackPublications().find((i) => i.source === t && i.trackName === n);
    if (n)
      return r.getTrackPublicationByName(n);
    if (t)
      return r.getTrackPublication(t);
    throw new Error("At least one of source and name needs to be defined");
  }
}
function fe(e, ...t) {
  return new k((r) => {
    const i = () => {
      r.next(e);
    };
    return t.forEach((s) => {
      e.on(s, i);
    }), () => {
      t.forEach((s) => {
        e.off(s, i);
      });
    };
  }).pipe(D(e));
}
function we(e, t) {
  return new k((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function os(e) {
  return we(e, y.ConnectionStateChanged).pipe(
    A(([t]) => t),
    D(e.state)
  );
}
function ss(e) {
  return fe(
    e,
    y.RoomMetadataChanged,
    y.ConnectionStateChanged
  ).pipe(
    A((n) => ({ name: n.name, metadata: n.metadata }))
  );
}
function as(e) {
  return we(e, y.ActiveSpeakersChanged).pipe(
    A(([t]) => t)
  );
}
function cs(e, t, n = !0) {
  const r = new k((o) => {
    Tt.getLocalDevices(e, n).then((s) => {
      o.next(s), o.complete();
    }).catch((s) => {
      t == null || t(s), o.next([]), o.complete();
    });
  }), i = new k((o) => {
    var s;
    const a = () => V(this, null, function* () {
      try {
        const c = yield Tt.getLocalDevices(e, n);
        o.next(c);
      } catch (c) {
        t == null || t(c);
      }
    });
    if (typeof window < "u") {
      if (!window.isSecureContext)
        throw new Error(
          "Accessing media devices is available only in secure contexts (HTTPS and localhost), in some or all supporting browsers. See: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/mediaDevices"
        );
      (s = navigator == null ? void 0 : navigator.mediaDevices) == null || s.addEventListener("devicechange", a);
    }
    return () => {
      var c;
      (c = navigator == null ? void 0 : navigator.mediaDevices) == null || c.removeEventListener("devicechange", a);
    };
  });
  return We(r, i);
}
function lo(e) {
  return we(e, y.DataReceived);
}
function fo(e) {
  return fe(e, y.AudioPlaybackStatusChanged).pipe(
    A((n) => ({ canPlayAudio: n.canPlaybackAudio }))
  );
}
function po(e) {
  return fe(e, y.VideoPlaybackStatusChanged).pipe(
    A((n) => ({ canPlayVideo: n.canPlaybackVideo }))
  );
}
function ho(e, t) {
  return we(e, y.ActiveDeviceChanged).pipe(
    Je(([n]) => n === t),
    A(([n, r]) => (L.debug("activeDeviceObservable | RoomEvent.ActiveDeviceChanged", { kind: n, deviceId: r }), r))
  );
}
function us(e, t) {
  return we(e, y.ParticipantEncryptionStatusChanged).pipe(
    Je(
      ([, n]) => (t == null ? void 0 : t.identity) === (n == null ? void 0 : n.identity) || !n && (t == null ? void 0 : t.identity) === e.localParticipant.identity
    ),
    A(([n]) => n),
    D(
      t != null && t.isLocal ? t.isE2EEEnabled : !!(t != null && t.isEncrypted)
    )
  );
}
function ls(e) {
  return we(e, y.RecordingStatusChanged).pipe(
    A(([t]) => t),
    D(e.isRecording)
  );
}
function xe(e, ...t) {
  return new k((r) => {
    const i = () => {
      r.next(e);
    };
    return t.forEach((s) => {
      e.on(s, i);
    }), () => {
      t.forEach((s) => {
        e.off(s, i);
      });
    };
  }).pipe(D(e));
}
function In(e) {
  return xe(
    e,
    w.TrackMuted,
    w.TrackUnmuted,
    w.ParticipantPermissionsChanged,
    // ParticipantEvent.IsSpeakingChanged,
    w.TrackPublished,
    w.TrackUnpublished,
    w.LocalTrackPublished,
    w.LocalTrackUnpublished,
    w.MediaDevicesError,
    w.TrackSubscriptionStatusChanged
    // ParticipantEvent.ConnectionQualityChanged,
  ).pipe(
    A((n) => {
      const { isMicrophoneEnabled: r, isCameraEnabled: i, isScreenShareEnabled: o } = n, s = n.getTrackPublication(R.Source.Microphone), a = n.getTrackPublication(R.Source.Camera);
      return {
        isCameraEnabled: i,
        isMicrophoneEnabled: r,
        isScreenShareEnabled: o,
        cameraTrack: a,
        microphoneTrack: s,
        participant: n
      };
    })
  );
}
function vo(e) {
  return e ? xe(
    e,
    w.ParticipantMetadataChanged,
    w.ParticipantNameChanged
  ).pipe(
    A(({ name: n, identity: r, metadata: i }) => ({
      name: n,
      identity: r,
      metadata: i
    })),
    D({
      name: e.name,
      identity: e.identity,
      metadata: e.metadata
    })
  ) : void 0;
}
function mo(e) {
  return Xe(
    e,
    w.ConnectionQualityChanged
  ).pipe(
    A(([n]) => n),
    D(e.connectionQuality)
  );
}
function Xe(e, t) {
  return new k((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function go(e) {
  var t, n, r, i;
  return xe(
    e.participant,
    w.TrackMuted,
    w.TrackUnmuted,
    w.TrackSubscribed,
    w.TrackUnsubscribed,
    w.LocalTrackPublished,
    w.LocalTrackUnpublished
  ).pipe(
    A((o) => {
      var s, a;
      const c = (s = e.publication) != null ? s : o.getTrackPublication(e.source);
      return (a = c == null ? void 0 : c.isMuted) != null ? a : !0;
    }),
    D(
      (i = (r = (t = e.publication) == null ? void 0 : t.isMuted) != null ? r : (n = e.participant.getTrackPublication(e.source)) == null ? void 0 : n.isMuted) != null ? i : !0
    )
  );
}
function fs(e) {
  return Xe(e, w.IsSpeakingChanged).pipe(
    A(([t]) => t)
  );
}
function ds(e, t = {}) {
  var n;
  let r;
  const i = new k((c) => (r = c, () => a.unsubscribe())).pipe(D(Array.from(e.remoteParticipants.values()))), o = (n = t.additionalRoomEvents) != null ? n : Cn, s = Array.from(
    /* @__PURE__ */ new Set([
      y.ParticipantConnected,
      y.ParticipantDisconnected,
      y.ConnectionStateChanged,
      ...o
    ])
  ), a = fe(e, ...s).subscribe(
    (c) => r == null ? void 0 : r.next(Array.from(c.remoteParticipants.values()))
  );
  return e.remoteParticipants.size > 0 && (r == null || r.next(Array.from(e.remoteParticipants.values()))), i;
}
function ps(e, t, n = {}) {
  var r;
  const i = (r = n.additionalEvents) != null ? r : Pn;
  return fe(
    e,
    y.ParticipantConnected,
    y.ParticipantDisconnected,
    y.ConnectionStateChanged
  ).pipe(
    Tn((s) => {
      const a = s.getParticipantByIdentity(t);
      return a ? xe(a, ...i) : new k((c) => c.next(void 0));
    }),
    D(e.getParticipantByIdentity(t))
  );
}
function hs(e) {
  return Xe(
    e,
    w.ParticipantPermissionsChanged
  ).pipe(
    A(() => e.permissions),
    D(e.permissions)
  );
}
function vs(e, { kind: t, identity: n }, r = {}) {
  var i;
  const o = (i = r.additionalEvents) != null ? i : Pn, s = (c) => {
    let u = !0;
    return t && (u = u && c.kind === t), n && (u = u && c.identity === n), u;
  };
  return fe(
    e,
    y.ParticipantConnected,
    y.ParticipantDisconnected,
    y.ConnectionStateChanged
  ).pipe(
    Tn((c) => {
      const u = Array.from(c.remoteParticipants.values()).find(
        (l) => s(l)
      );
      return u ? xe(u, ...o) : new k((l) => l.next(void 0));
    }),
    D(Array.from(e.remoteParticipants.values()).find((c) => s(c)))
  );
}
function ms(e) {
  return typeof e > "u" ? new k() : Xe(e, w.AttributesChanged).pipe(
    A(([t]) => ({
      changed: t,
      attributes: e.attributes
    })),
    D({ changed: e.attributes, attributes: e.attributes })
  );
}
function gs(e, t, n, r, i) {
  const { localParticipant: o } = t, s = (f, v) => {
    let d = !1;
    switch (f) {
      case R.Source.Camera:
        d = v.isCameraEnabled;
        break;
      case R.Source.Microphone:
        d = v.isMicrophoneEnabled;
        break;
      case R.Source.ScreenShare:
        d = v.isScreenShareEnabled;
        break;
    }
    return d;
  }, a = In(o).pipe(
    A((f) => s(e, f.participant)),
    D(s(e, o))
  ), c = new ee(), u = (f, v) => V(this, null, function* () {
    try {
      switch (v ?? (v = n), c.next(!0), e) {
        case R.Source.Camera:
          return yield o.setCameraEnabled(
            f ?? !o.isCameraEnabled,
            v,
            r
          ), o.isCameraEnabled;
        case R.Source.Microphone:
          return yield o.setMicrophoneEnabled(
            f ?? !o.isMicrophoneEnabled,
            v,
            r
          ), o.isMicrophoneEnabled;
        case R.Source.ScreenShare:
          return yield o.setScreenShareEnabled(
            f ?? !o.isScreenShareEnabled,
            v,
            r
          ), o.isScreenShareEnabled;
        default:
          throw new TypeError("Tried to toggle unsupported source");
      }
    } catch (d) {
      if (i && d instanceof Error) {
        i == null || i(d);
        return;
      } else
        throw d;
    } finally {
      c.next(!1);
    }
  });
  return {
    className: U("button"),
    toggle: u,
    enabledObserver: a,
    pendingObserver: c.asObservable()
  };
}
function bs() {
  let e = !1;
  const t = new ee(), n = new ee(), r = (o) => V(this, null, function* () {
    n.next(!0), e = o ?? !e, t.next(e), n.next(!1);
  });
  return {
    className: U("button"),
    toggle: r,
    enabledObserver: t.asObservable(),
    pendingObserver: n.asObservable()
  };
}
function ys(e, t, n) {
  const r = new ln(void 0), i = ho(t, e), o = (a, ...c) => V(this, [a, ...c], function* (u, l = {}) {
    var f, v, d;
    if (t) {
      const m = Yn();
      if (e === "audiooutput" && ((m == null ? void 0 : m.name) === "Safari" || (m == null ? void 0 : m.os) === "iOS")) {
        L.warn("Switching audio output device is not supported on Safari and iOS.");
        return;
      }
      L.debug(`Switching active device of kind "${e}" with id ${u}.`), yield t.switchActiveDevice(e, u, l.exact);
      const p = (f = t.getActiveDevice(e)) != null ? f : u;
      p !== u && u !== "default" && L.info(
        `We tried to select the device with id (${u}), but the browser decided to select the device with id (${p}) instead.`
      );
      let g;
      e === "audioinput" ? g = (v = t.localParticipant.getTrackPublication(R.Source.Microphone)) == null ? void 0 : v.track : e === "videoinput" && (g = (d = t.localParticipant.getTrackPublication(R.Source.Camera)) == null ? void 0 : d.track);
      const h = u === "default" && !g || u === "default" && (g == null ? void 0 : g.mediaStreamTrack.label.startsWith("Default"));
      r.next(h ? u : p);
    }
  });
  return {
    className: U("media-device-select"),
    activeDeviceObservable: i,
    setActiveMediaDevice: o
  };
}
function ws(e) {
  const t = (r) => {
    e.disconnect(r);
  };
  return { className: U("disconnect-button"), disconnect: t };
}
function xs(e) {
  const t = U("connection-quality"), n = mo(e);
  return { className: t, connectionQualityObserver: n };
}
function Ss(e) {
  let t = "track-muted-indicator-camera";
  switch (e.source) {
    case R.Source.Camera:
      t = "track-muted-indicator-camera";
      break;
    case R.Source.Microphone:
      t = "track-muted-indicator-microphone";
      break;
  }
  const n = U(t), r = go(e);
  return { className: n, mediaMutedObserver: r };
}
function Ts(e) {
  return { className: "lk-participant-name", infoObserver: vo(e) };
}
function Es() {
  return {
    className: U("participant-tile")
  };
}
var bo = {
  CHAT: "lk.chat",
  TRANSCRIPTION: "lk.transcription"
}, yo = {
  CHAT: "lk-chat-topic"
};
function Mn(e, t) {
  return V(this, arguments, function* (n, r, i = {}) {
    const { reliable: o, destinationIdentities: s, topic: a } = i;
    yield n.publishData(r, {
      destinationIdentities: s,
      topic: a,
      reliable: o
    });
  });
}
function wo(e, t, n) {
  const r = Array.isArray(t) ? t : [t], i = lo(e).pipe(
    Je(
      ([, , , c]) => t === void 0 || c !== void 0 && r.includes(c)
    ),
    A(([c, u, , l]) => {
      const f = {
        payload: c,
        topic: l,
        from: u
      };
      return n == null || n(f), f;
    })
  );
  let o;
  const s = new k((c) => {
    o = c;
  });
  return { messageObservable: i, isSendingObservable: s, send: (c, ...u) => V(this, [c, ...u], function* (l, f = {}) {
    o.next(!0);
    try {
      yield Mn(e.localParticipant, l, Y({ topic: r[0] }, f));
    } finally {
      o.next(!1);
    }
  }) };
}
var Ie = /* @__PURE__ */ new WeakMap();
function xo(e) {
  return e.ignoreLegacy == !0;
}
var So = (e) => JSON.parse(new TextDecoder().decode(e)), To = (e) => new TextEncoder().encode(JSON.stringify(e));
function Cs(e, t) {
  var n, r, i, o, s, a;
  const c = () => {
    var b, S, C;
    return ((b = e.serverInfo) == null ? void 0 : b.edition) === 1 || !!((S = e.serverInfo) != null && S.version) && qn((C = e.serverInfo) == null ? void 0 : C.version, "1.8.2") > 0;
  }, u = new ee(), l = (n = t == null ? void 0 : t.channelTopic) != null ? n : bo.CHAT, f = (r = t == null ? void 0 : t.channelTopic) != null ? r : yo.CHAT;
  let v = !1;
  Ie.has(e) || (v = !0);
  const d = (i = Ie.get(e)) != null ? i : /* @__PURE__ */ new Map(), m = (o = d.get(l)) != null ? o : new ee();
  d.set(l, m), Ie.set(e, d);
  const p = (s = t == null ? void 0 : t.messageDecoder) != null ? s : So;
  if (v) {
    e.registerTextStreamHandler(l, (S, C) => V(this, null, function* () {
      const { id: $, timestamp: M } = S.info;
      Qe(S).pipe(
        ut((T, _) => T + _),
        A((T) => ({
          id: $,
          timestamp: M,
          message: T,
          from: e.getParticipantByIdentity(C.identity),
          type: "chatMessage"
          // editTimestamp: type === 'update' ? timestamp : undefined,
        }))
      ).subscribe({
        next: (T) => m.next(T)
      });
    }));
    const { messageObservable: b } = wo(e, [f]);
    b.pipe(
      A((S) => {
        const C = p(S.payload);
        return xo(C) ? void 0 : se(Y({}, C), {
          type: "chatMessage",
          from: S.from
        });
      }),
      Je((S) => !!S),
      Nt(u)
    ).subscribe(m);
  }
  const g = m.pipe(
    ut((b, S) => {
      if ("id" in S && b.find((C) => {
        var $, M;
        return (($ = C.from) == null ? void 0 : $.identity) === ((M = S.from) == null ? void 0 : M.identity) && C.id === S.id;
      })) {
        const C = b.findIndex(($) => $.id === S.id);
        if (C > -1) {
          const $ = b[C];
          b[C] = se(Y({}, S), {
            timestamp: $.timestamp,
            editTimestamp: S.timestamp
          });
        }
        return [...b];
      }
      return [...b, S];
    }, []),
    Nt(u)
  ), h = new ln(!1), x = (a = t == null ? void 0 : t.messageEncoder) != null ? a : To, E = (b, S) => V(this, null, function* () {
    var C;
    S || (S = {}), (C = S.topic) != null || (S.topic = l), h.next(!0);
    try {
      const M = {
        id: (yield e.localParticipant.sendText(b, S)).id,
        timestamp: Date.now(),
        message: b
      }, z = se(Y({}, M), {
        attachedFiles: S.attachments
      }), T = se(Y({}, z), {
        type: "chatMessage",
        from: e.localParticipant,
        attributes: S.attributes
      });
      m.next(T);
      const _ = x(se(Y({}, M), {
        ignoreLegacy: c()
      }));
      try {
        yield Mn(e.localParticipant, _, {
          reliable: !0,
          topic: f
        });
      } catch (Z) {
        L.info("could not send message in legacy chat format", Z);
      }
      return T;
    } finally {
      h.next(!1);
    }
  });
  function O() {
    u.next(), u.complete(), m.complete(), Ie.delete(e), e.unregisterTextStreamHandler(l);
  }
  return e.once(y.Disconnected, O), {
    messageObservable: g,
    isSendingObservable: h,
    send: E
  };
}
function Ps() {
  const e = (n) => V(this, null, function* () {
    L.info("Start Audio for room: ", n), yield n.startAudio();
  });
  return { className: U("start-audio-button"), roomAudioPlaybackAllowedObservable: fo, handleStartAudioPlayback: e };
}
function Os() {
  const e = (n) => V(this, null, function* () {
    L.info("Start Video for room: ", n), yield n.startVideo();
  });
  return { className: U("start-audio-button"), roomVideoPlaybackAllowedObservable: po, handleStartVideoPlayback: e };
}
function As() {
  return { className: [U("button"), U("chat-toggle")].join(" ") };
}
function ks() {
  return { className: [U("button"), U("focus-toggle-button")].join(" ") };
}
function _s() {
  return { className: "lk-clear-pin-button lk-button" };
}
function Ls() {
  return { className: "lk-room-container" };
}
function Vt(e, t, n = !0) {
  const i = [e.localParticipant, ...Array.from(e.remoteParticipants.values())], o = [];
  return i.forEach((s) => {
    t.forEach((a) => {
      const c = Array.from(
        s.trackPublications.values()
      ).filter(
        (u) => u.source === a && // either return all or only the ones that are subscribed
        (!n || u.track)
      ).map((u) => ({
        participant: s,
        publication: u,
        source: u.source
      }));
      o.push(...c);
    });
  }), { trackReferences: o, participants: i };
}
function Ht(e, t, n = !1) {
  const { sources: r, kind: i, name: o } = t;
  return Array.from(e.trackPublications.values()).filter(
    (a) => (!r || r.includes(a.source)) && (!i || a.kind === i) && (!o || a.trackName === o) && // either return all or only the ones that are subscribed
    (!n || a.track)
  ).map((a) => ({
    participant: e,
    publication: a,
    source: a.source
  }));
}
function Is(e, t, n) {
  var r, i;
  const o = (r = n.additionalRoomEvents) != null ? r : Cn, s = (i = n.onlySubscribed) != null ? i : !0, a = Array.from(
    (/* @__PURE__ */ new Set([
      y.ParticipantConnected,
      y.ParticipantDisconnected,
      y.ConnectionStateChanged,
      y.LocalTrackPublished,
      y.LocalTrackUnpublished,
      y.TrackPublished,
      y.TrackUnpublished,
      y.TrackSubscriptionStatusChanged,
      ...o
    ])).values()
  );
  return fe(e, ...a).pipe(
    A((u) => {
      const l = Vt(u, t, s);
      return L.debug(`TrackReference[] was updated. (length ${l.trackReferences.length})`, l), l;
    }),
    D(Vt(e, t, s))
  );
}
function Ms(e, t) {
  return xe(e, ...qi).pipe(
    A((r) => {
      const i = Ht(r, t);
      return L.debug(`TrackReference[] was updated. (length ${i.length})`, i), i;
    }),
    D(Ht(e, t))
  );
}
function Rn(e, t) {
  return new k((r) => {
    const i = (...s) => {
      r.next(s);
    };
    return e.on(t, i), () => {
      e.off(t, i);
    };
  });
}
function Rs(e) {
  return Rn(e, Yt.TranscriptionReceived);
}
function Ds(e) {
  return Rn(e, Yt.TimeSyncUpdate).pipe(
    A(([t]) => t)
  );
}
function $s(e, t = 1e3) {
  if (e === null) return Dt(!1);
  const n = ct(e, "mousemove", { passive: !0 }).pipe(A(() => !0)), r = n.pipe(
    mi({
      each: t,
      with: () => We(Dt(!1), r.pipe(Ri(n)))
    }),
    Li()
  );
  return r;
}
function Eo(e, t) {
  if (typeof localStorage > "u") {
    L.error("Local storage is not available.");
    return;
  }
  try {
    if (t) {
      const n = Object.fromEntries(
        Object.entries(t).filter(([, r]) => r !== "")
      );
      localStorage.setItem(e, JSON.stringify(n));
    }
  } catch (n) {
    L.error(`Error setting item to local storage: ${n}`);
  }
}
function Co(e) {
  if (typeof localStorage > "u") {
    L.error("Local storage is not available.");
    return;
  }
  try {
    const t = localStorage.getItem(e);
    if (!t) {
      L.warn(`Item with key ${e} does not exist in local storage.`);
      return;
    }
    return JSON.parse(t);
  } catch (t) {
    L.error(`Error getting item from local storage: ${t}`);
    return;
  }
}
function Po(e) {
  return {
    load: () => Co(e),
    save: (t) => Eo(e, t)
  };
}
var Oo = `${En}-user-choices`, Te = {
  videoEnabled: !0,
  audioEnabled: !0,
  videoDeviceId: "default",
  audioDeviceId: "default",
  username: ""
}, { load: Ao, save: ko } = Po(Oo);
function Ns(e, t = !1) {
  t !== !0 && ko(e);
}
function Fs(e, t = !1) {
  var n, r, i, o, s;
  const a = {
    videoEnabled: (n = e == null ? void 0 : e.videoEnabled) != null ? n : Te.videoEnabled,
    audioEnabled: (r = e == null ? void 0 : e.audioEnabled) != null ? r : Te.audioEnabled,
    videoDeviceId: (i = e == null ? void 0 : e.videoDeviceId) != null ? i : Te.videoDeviceId,
    audioDeviceId: (o = e == null ? void 0 : e.audioDeviceId) != null ? o : Te.audioDeviceId,
    username: (s = e == null ? void 0 : e.username) != null ? s : Te.username
  };
  if (t)
    return a;
  {
    const c = Ao();
    return Y(Y({}, a), c ?? {});
  }
}
var rt = null, it = null, _o = 0;
function zt() {
  return rt || (rt = /* @__PURE__ */ new Map()), rt;
}
function Lo() {
  return it || (it = /* @__PURE__ */ new WeakMap()), it;
}
function Io(e, t) {
  const n = Lo();
  let r = n.get(e);
  return r || (r = `room_${_o++}`, n.set(e, r)), `${r}:${t}`;
}
function Us(e, t) {
  const n = Io(e, t), r = zt(), i = r.get(n);
  if (i)
    return i;
  const o = new ee();
  let s = [];
  const a = "lk.segment_id", c = o.pipe(
    Di({
      subscribe: () => {
        e.registerTextStreamHandler(t, (u, l) => V(this, null, function* () {
          var f;
          const v = Qe(u).pipe(
            ut((m, p) => m + p, "")
          ), d = !!((f = u.info.attributes) != null && f[a]);
          v.subscribe((m) => {
            const p = s.findIndex(
              (g) => {
                var h, x;
                return g.streamInfo.id === u.info.id || d && ((h = g.streamInfo.attributes) == null ? void 0 : h[a]) === ((x = u.info.attributes) == null ? void 0 : x[a]);
              }
            );
            p !== -1 ? (s[p] = se(Y({}, s[p]), {
              text: m
            }), o.next([...s])) : (s.push({
              text: m,
              participantInfo: l,
              streamInfo: u.info
            }), o.next([...s]));
          });
        }));
      },
      finalize: () => {
        e.unregisterTextStreamHandler(t);
      }
    }),
    Mi()
  );
  return r.set(n, c), e.on(y.Disconnected, () => {
    zt().delete(n), s = [], o.next([]);
  }), c;
}
function Dn(e, t) {
  if (t.msg === "show_chat")
    return { ...e, showChat: !0, unreadMessages: 0 };
  if (t.msg === "hide_chat")
    return { ...e, showChat: !1 };
  if (t.msg === "toggle_chat") {
    const n = { ...e, showChat: !e.showChat };
    return n.showChat === !0 && (n.unreadMessages = 0), n;
  } else return t.msg === "unread_msg" ? { ...e, unreadMessages: t.count } : t.msg === "toggle_settings" ? { ...e, showSettings: !e.showSettings } : { ...e };
}
function $n(e, t) {
  return t.msg === "set_pin" ? [t.trackReference] : t.msg === "clear_pin" ? [] : { ...e };
}
const Nn = I.createContext(void 0);
function js() {
  const e = I.useContext(Nn);
  if (!e)
    throw Error("Tried to access LayoutContext context outside a LayoutContextProvider provider.");
  return e;
}
function Ws(e) {
  const t = Mo();
  if (e ?? (e = t), !e)
    throw Error("Tried to access LayoutContext context outside a LayoutContextProvider provider.");
  return e;
}
function Bs() {
  const [e, t] = I.useReducer($n, On), [n, r] = I.useReducer(Dn, An);
  return {
    pin: { dispatch: t, state: e },
    widget: { dispatch: r, state: n }
  };
}
function Vs(e) {
  const [t, n] = I.useReducer($n, On), [r, i] = I.useReducer(Dn, An);
  return e ?? {
    pin: { dispatch: n, state: t },
    widget: { dispatch: i, state: r }
  };
}
function Mo() {
  return I.useContext(Nn);
}
const Fn = I.createContext(
  void 0
);
function Hs() {
  const e = I.useContext(Fn);
  if (!e)
    throw Error("tried to access track context outside of track context provider");
  return e;
}
function Un() {
  return I.useContext(Fn);
}
function zs(e) {
  const t = Un(), n = e ?? t;
  if (!n)
    throw new Error(
      "No TrackRef, make sure you are inside a TrackRefContext or pass the TrackRef explicitly"
    );
  return n;
}
const jn = I.createContext(void 0);
function Ys() {
  const e = I.useContext(jn);
  if (!e)
    throw Error("tried to access participant context outside of participant context provider");
  return e;
}
function Ro() {
  return I.useContext(jn);
}
function qs(e) {
  const t = Ro(), n = Un(), r = e ?? t ?? (n == null ? void 0 : n.participant);
  if (!r)
    throw new Error(
      "No participant provided, make sure you are inside a participant context or pass the participant explicitly"
    );
  return r;
}
const Wn = I.createContext(void 0);
function Ks() {
  const e = I.useContext(Wn);
  if (!e)
    throw Error("tried to access room context outside of livekit room component");
  return e;
}
function Do() {
  return I.useContext(Wn);
}
function Gs(e) {
  const t = Do(), n = e ?? t;
  if (!n)
    throw new Error(
      "No room provided, make sure you are inside a Room context or pass the room explicitly"
    );
  return n;
}
const Bn = I.createContext(void 0);
function Qs() {
  const e = I.useContext(Bn);
  if (!e)
    throw Error("tried to access session context outside of SessionProvider component");
  return e;
}
function $o() {
  return I.useContext(Bn);
}
function Js(e) {
  const t = $o(), n = e ?? t;
  if (!n)
    throw new Error(
      "No session provided, make sure you are inside a Session context or pass the session explicitly"
    );
  return n;
}
const No = I.createContext(void 0);
function Xs(e) {
  const t = I.useContext(No);
  if (e === !0) {
    if (t)
      return t;
    throw Error("tried to access feature context, but none is present");
  }
  return t;
}
export {
  Ns as $,
  rs as A,
  Ro as B,
  vo as C,
  Es as D,
  ds as E,
  Ws as F,
  Qo as G,
  ps as H,
  vs as I,
  ss as J,
  as as K,
  No as L,
  ns as M,
  Ps as N,
  Os as O,
  As as P,
  Ss as Q,
  Wn as R,
  gs as S,
  bs as T,
  Xi as U,
  Is as V,
  es as W,
  Bt as X,
  is as Y,
  Cs as Z,
  Fs as _,
  js as a,
  us as a0,
  B as a1,
  Ms as a2,
  Ds as a3,
  Rs as a4,
  Zo as a5,
  Xo as a6,
  ms as a7,
  Ji as a8,
  ls as a9,
  Ys as aA,
  Qs as aB,
  Hs as aC,
  Us as aa,
  bo as ab,
  $o as ac,
  Js as ad,
  Un as ae,
  Nn as af,
  Ts as ag,
  Uo as ah,
  kr as ai,
  jn as aj,
  Fn as ak,
  Xs as al,
  $s as am,
  Bo as an,
  Vs as ao,
  qo as ap,
  Yo as aq,
  Bn as ar,
  Ho as as,
  zo as at,
  Jo as au,
  Bs as av,
  jo as aw,
  Vo as ax,
  Ko as ay,
  Go as az,
  _s as b,
  qs as c,
  xs as d,
  os as e,
  Ks as f,
  wo as g,
  ws as h,
  zs as i,
  Mo as j,
  ks as k,
  L as l,
  Wo as m,
  Gi as n,
  go as o,
  N as p,
  fs as q,
  fo as r,
  Ls as s,
  In as t,
  Gs as u,
  hs as v,
  Do as w,
  cs as x,
  ys as y,
  ts as z
};
//# sourceMappingURL=contexts-CjCD4TaH.mjs.map
